<template>
	<div class="view" >
		<div class="img" >
			<div :data-i="item" :class="['img_item','i'+item]" v-for="item in 61" >
				<img :data-src="g+'/'+(item+1)+'.png'" class="img_item_img" />
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: "",
		components: {},
		data(){
			 let g=process.env.VUE_APP_BASE_URL+'sustainability'
			return{
				g:g
			}
		}
	}
</script>

<style scoped lang="scss">
	.view{
		    height: 355px;
		    width: 348px;
			.img{
				position: relative;
				.img_item_img{
					left: 0px;
					    position: absolute;
					    top: 0px;
				}
			}
			.i1{
				height: 17.54px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(0.000px, 131.119px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 22.19px;
			}
			.i2{
				    height: 7.93px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(5.268px, 120.510px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 20.27px;
			}
			.i3{
				    height: 18.93px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(10.086px, 100.449px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 22.27px
			}
			.i4{
				height: 11.91px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(18.918px, 89.549px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 24.75px;
			}
			.i5{
				    height: 23.98px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(29.670px, 62.602px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 25.28px;
			}
			.i6{
				    height: 21.69px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(41.800px, 45.742px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 21.65px;
			}
			.i7{
				    height: 20.12px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(71.368px, 30.628px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 21.36px;
			}
			.i8{
				height: 19.67px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(96.455px, 17.254px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 20.57px
			}
			.i9{
				    height: 6.96px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(112.739px, 10.462px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 2.83px;
			}
			.i10{
				height: 23.84px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(122.843px, 3.921px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 19.08px;
			}
			.i11{
				height: 22.78px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(144.257px, 0.423px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 18.64px;
			}
			.i12{
				    height: 21.06px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(167.376px, 0.000px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 17.14px;
			}
			.i13{
				height: 20.98px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(188.841px, 0.909px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 3.39px;
			}
			.i14{
				height: 23.60px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(196.863px, 2.012px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 18.26px;
			}
			.i15{
				height: 21.97px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(219.399px, 9.198px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 20.39px;
			}
			.i16{
				    height: 26.11px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(240.386px, 17.184px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 24.14px;
			}
			.i17{
				    height: 26.48px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(260.129px, 29.805px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 25.46px;
			}
			.i18{
				height: 24.96px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(278.078px, 45.479px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 24.69px;
			}
			.i19{
				height: 28.67px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(291.714px, 61.204px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 28.84px;
				}
			
			.i20{
				height: 22.67px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(307.269px, 85.109px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 25.17px;
			}
			.i21{
				height: 22.80px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(316.417px, 104.554px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 25.46px;
			}
			.i22{
				height: 15.83px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(325.545px, 126.249px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 22.45px;
			}
			.i23{
				height: 9.63px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(0.404px, 174.661px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 9.63px;
			}
			.i24{
				height: 18.15px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(1.669px, 210.713px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 21.86px;
			}
			.i25{
				height: 8.44px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(7.517px, 231.251px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 20.12px;
			}
			.i26{
				height: 19.76px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(13.192px, 241.136px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 21.76px;
			}
			.i27{
				height: 22.52px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(22.815px, 258.915px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 18.23px;
			}
			.i28{
				height: 24.41px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(34.607px, 273.832px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 25.10px;
			}
			.i29{
				height: 21.99px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(53.939px, 286.950px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 21.30px;
			}
			.i30{
				height: 23.09px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(89.409px, 316.889px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 16.58px;
			}
			.i31{
				height: 22.14px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(134.284px, 330.513px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 17.18px;
			}
			.i32{
				    height: 21.79px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(158.449px, 333.453px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 16.58px;
			}
			.i33{
				height: 21.88px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(182.152px, 332.663px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 16.61px;
			}
			.i34{
				height: 22.36px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(200.628px, 328.256px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 15.90px;
			}
			.i35{
				height: 23.02px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(223.799px, 324.906px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 17.10px
			}
			.i36{
				height: 19.57px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(238.897px, 319.235px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 9.95px;
			}
			.i37{
				    height: 26.29px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(246.873px, 307.813px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 24.64px;
				
			}
			.i38{
				height: 22.49px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(271.178px, 299.083px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 20.68px
			}
			.i39{
				    height: 23.09px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(282.095px, 281.960px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 23.56px
			}
			.i40{
				height: 13.85px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(296.943px, 272.898px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 17.37px;
			}
			.i41{
				    height: 12.39px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(302.408px, 265.554px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 24.75px;
			}
			.i42{
				    height: 10.84px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(312.058px, 249.397px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 19.17px;
			}
			.i43{
				    height: 16.02px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(315.285px, 229.697px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 22.68px
			}
			.i44{
				height: 17.46px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(322.386px, 209.550px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 22.75px;
			}
			.i45{
				height: 9.63px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(337.790px, 174.650px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 9.63px;
			}
			.i46{
				    height: 28.04px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(216.331px, 132.596px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 46.42px;
			}
			.i47{
				height: 158.66px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(144.430px, 112.253px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 66.44px;
			}
			.i48{
				    height: 65.04px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(86.347px, 205.867px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 96.56px;
			}
			.i49{
				height: 27.06px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(143.620px, 191.910px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 13.63px;
			}
			.i50{
				height: 6.54px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(108.816px, 145.444px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 11.72px
			}
			.i51{
				height: 46.10px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(183.104px, 145.444px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 11.73px;
			}
			.i52{
				height: 33.24px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(55.362px, 158.713px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 44.49px;
			}
			.i53{
				eight: 33.23px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(129.534px, 158.778px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 44.60px;
			}
			.i54{
				height: 33.29px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(204.098px, 158.737px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 44.70px;
			}
			.i55{
				    height: 46.88px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(252.204px, 159.014px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 45.58px
			}
			.i56{
				height: 32.34px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(108.832px, 159.222px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 11.71px;
			}
			.i57{
				height: 13.27px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(195.643px, 203.031px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 12.94px;
			}
			.i58{
				height: 12.57px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(143.000px, 203.416px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 12.21px;
			}
			.i59{
				    height: 12.53px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(155.035px, 203.456px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 14.50px;
			}
			.i60{
				height: 12.58px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(172.438px, 203.407px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 13.57px;
			}
			.i61{
				    height: 12.53px;
				    left: 0px;
				    position: absolute;
				    top: 0px;
				    transform: translate(189.514px, 203.456px) rotate(0.000deg) skew(0.000deg) scale(1.000, 1.000);
				    transform-origin: 0% 0%;
				    width: 2.30px;
			}
	}
	
</style>